module.exports = __webpack_public_path__ + "static/media/Slide1.a6c90621.png";